import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const StatusGroupTreeServiceConfig = {
  name: "StatusGroupTree",
  annotations: []
} as ServiceConfig;